import { dbGet } from "./indexedDBService"

const useBlock = () => {

    const cloneElement = (originalElements, newElement) => {

        // Recherche de la correspondance à la racine d'originalElements
        const currentIndex = originalElements.findIndex(element => element.id === newElement.id);

        if(currentIndex !== -1){

            // On clone en profondeur le bloc d'origine pour ne pas muter l'état courant
            // utilisé ailleurs dans l'application.
            const blockToClone = JSON.parse(JSON.stringify(originalElements[currentIndex]));

            // Initialiser le nouvel element (nouvel id, ids des enfants, position d'insertion)
            const {id, index} = initElement(blockToClone, originalElements);

            // Intégrer le nouvel element dans le tableau à l'index donné
            originalElements.splice(index, 0, blockToClone);

            return {id: id, elements: [...originalElements]};
        }
    }

    const initElement = (block, originalElements) => {

        // Numéro de suffixe essayé pour le nouvel id (bloc et enfants)
        let nextNumber = 1;
        let nextId;

        // Position d'insertion par défaut : juste après le bloc d'origine
        const originalIndex = originalElements.findIndex(element => element.id === block.id);
        let nextIndex = originalIndex + 1;

        // Recherche d'un suffixe libre pour cet id de bloc à la racine
        while(nextNumber < 100){

            // Créer un nouvel id basé sur la racine de l'id d'origine
            const tempId = createId(block.id, nextNumber);

            // Vérifier si le nouvel id existe déjà dans le tableau
            const existe = originalElements.findIndex(element => element.id === tempId);

            if(existe !== -1){
                // L'id est déjà utilisé : on incrémente le suffixe et on insère
                // le bloc cloné après la dernière occurrence trouvée
                nextNumber += 1;
                nextIndex = existe + 1;
            } else {
                nextId = tempId;
                break;
            }
        }

        // Cas limite : si tous les suffixes ~1 à ~99 sont utilisés, on force
        // un id unique avec un timestamp pour éviter un id undefined.
        if(!nextId){
            nextId = block.id ? block.id.split('~')[0] + '~' + new Date().getTime() : 'block~' + new Date().getTime();
        }

        // Affecter le nouvel id au bloc cloné
        block.id = nextId;

        // Met à jour récursivement les ids des enfants en conservant la même
        // logique de suffixe pour garder des groupes cohérents.
        const updateChildren = (children) => {
            children.forEach(child => {
                child.id = createId(child.id, nextNumber);
                if(child.elements) updateChildren(child.elements);
            });
        }

        if(block.elements){
            updateChildren(block.elements);
        }

        return {id: nextId, index: nextIndex};
    }

    const createId = (originalId, nextNumber) => {

        // Sécurise le cas où l'id d'origine serait vide ou indéfini
        if(!originalId){
            return 'block~' + nextNumber;
        }

        // On se base toujours sur la racine de l'id avant le premier '~'
        // pour éviter d'accumuler ou de tronquer des suffixes successifs
        const baseId = originalId.split('~')[0];

        return baseId + '~' + nextNumber;
    }

    const getNewElements = async (visite, newBlock) => {

        const contentId = [visite.uid, visite.type_bien];
        
        return await dbGet('visits_content', contentId)
        .then(result => {
            if(result){
                const originalElements = result.content;
                const finalContent = cloneElement(originalElements, newBlock);
                return finalContent;
            }
        });
    }

    const deleteBlock = async (visite, block) => {

        const contentId = [visite.uid, visite.type_bien];

        return await dbGet('visits_content', contentId)
        .then(result => {

            const originalElements = result.content;
            const index = originalElements.findIndex(element => element.id === block.id);

            if(index !== -1){
                
                const nextElements = originalElements.filter(element => element.id !== block.id);
                return [...nextElements];
    
            }
        });

    }

    return { getNewElements, deleteBlock }

}

export default useBlock;